// Browser-Kompatibilität sicherstellen
if (typeof (globalThis as any).global === 'undefined') {
  ;(globalThis as any).global = globalThis
}

// Produktions-Entry-Point nur für Web-Komponenten (ohne Dev-App)
import './assets/main.css'
import { defineAllWebComponents } from './composables/useWebComponents'
import { registerAllWebComponents } from './composables/useComponentRegistry'

/**
 * Hauptinitialisierung für Web-Komponenten (Produktionsversion)
 */
async function initWebComponents(): Promise<void> {
  try {
    console.log('🚀 Lade Web-Komponenten...')

    // Web-Komponenten laden und registrieren
    await registerAllWebComponents()

    // Alle Web-Komponenten definieren
    defineAllWebComponents()

    console.log('Web-Komponenten erfolgreich geladen')
  } catch (error) {
    console.error('Fehler beim Laden der Web-Komponenten:', error)
  }
}

// Web-Komponenten initialisieren
initWebComponents()

// Optional: Globale API für externe Nutzung bereitstellen
if (typeof window !== 'undefined') {
  ;(window as any).__BULMA_VUE_WEBCOMPONENTS__ = {
    version: '1.0.0',
    loadComponent: async (tagName: string) => {
      const { registerComponentByName } = await import('./composables/useComponentRegistry')
      return registerComponentByName(tagName)
    },
    getRegisteredComponents: async () => {
      const { getRegisteredWebComponents } = await import('./composables/useWebComponents')
      return getRegisteredWebComponents()
    },
  }
}
